import { render, staticRenderFns } from "./CbsRecordPage.vue?vue&type=template&id=25113826&scoped=true"
import script from "./CbsRecordPage.vue?vue&type=script&lang=js"
export * from "./CbsRecordPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25113826",
  null
  
)

export default component.exports